import { HIDE_LOADING } from '../Actions/types'

const initialState = {
    loading: true
}

export default function showLoading (state = initialState, action) {
    switch(action.type) {
        case HIDE_LOADING: 
    
            return {
             ...state,
               loading: action.payload
            };
        
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/Reducers/LoadingReducer.js